export async function fileResponse(url, jwt) {
    const response = await fetch(url, {
        method: 'get',
        cache: 'no-cache',
        headers: {
            'Content-Type': 'application/json',
            authorization: `Bearer ${jwt}`
        }
    });
    if (response.ok) {
        return {
            status: 200,
            headers: {
                'content-disposition': response.headers.get('content-disposition'),
                'content-type': response.headers.get('content-type'),
                'content-length': response.headers.get('content-length')
            },
            body: new Uint8Array(await response.arrayBuffer())
        };
    }
    return {
        status: response.status,
        body: await response.text()
    };
}
export async function validarHorario(horario, accion) {
    const currentHour = new Date().getHours();
    const { inicio, fin } = horario;
    if (currentHour < inicio || currentHour >= fin) {
        return {
            valido: false,
            mensaje: `No puedes ${accion} auditoría en este momento. El horario establecido es desde ${inicio}:00 hasta las ${fin}:00.`
        };
    }
    return { valido: true };
}
